// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ca-0";
export var actionModalContentContainer = "_ca-1";
export var createTagButton = "_ca-2";
export var footerContainer = "_ca-7";
export var fullWidthDivider = "_ca-3";
export var hasCreateTagButton = "_ca-4";
export var noCreateTagButton = "_ca-5";
export var tagsContainer = "_ca-6";
export var tagsModalContentContainer = "_ca-8";